var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6047 10.2301C19.6047 9.55039 19.5496 8.86697 19.432 8.19824H10V12.0489H15.4013C15.1771 13.2908 14.457 14.3895 13.4024 15.0876V17.5861H16.6248C18.5171 15.8445 19.6047 13.2725 19.6047 10.2301Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99844 20C12.6954 20 14.9698 19.1145 16.6269 17.586L13.4045 15.0874C12.508 15.6974 11.3506 16.0428 10.0021 16.0428C7.39335 16.0428 5.18141 14.2828 4.38776 11.9165H1.0625V14.4922C2.76004 17.8689 6.21757 20 9.99844 20Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3853 11.9165C3.96643 10.6746 3.96643 9.32982 4.3853 8.0879V5.51221H1.06371C-0.354572 8.33776 -0.354572 11.6667 1.06371 14.4922L4.3853 11.9165Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99844 3.95791C11.4241 3.93587 12.8019 4.47232 13.8344 5.45704L16.6894 2.60209C14.8816 0.904556 12.4823 -0.0287207 9.99844 0.000673865C6.21757 0.000673865 2.76003 2.13178 1.0625 5.51215L4.38408 8.08785C5.17406 5.71791 7.38968 3.95791 9.99844 3.95791Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleicon);
export default __webpack_public_path__ + "static/media/googleicon.66829ebb53e539d1d6f7d7ee63694f62.svg";
export { ForwardRef as ReactComponent };